import { Link } from "react-router-dom";
import { useCookieConsent } from "../hooks/useCookieConsent";

export function CookieBanner() {
  const { accepted, accept, acceptEssentialOnly } = useCookieConsent();

  if (accepted !== null) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-neutral-border shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-neutral-text/80 font-body flex-1">
          Мы используем localStorage для авторизации через Telegram и сохранения прогресса обучения.
          Персональные данные обрабатываются в соответствии с{" "}
          <Link to="/privacy" className="text-primary hover:underline">
            Политикой конфиденциальности
          </Link>
          .
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={acceptEssentialOnly}
            className="px-4 py-2 text-sm border border-neutral-border rounded-lg text-neutral-text/70 hover:bg-neutral-light transition-colors"
          >
            Только обязательные
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-semibold"
          >
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
